import { styled } from "@mui/material/styles";
import Section, { sectionClasses } from "@bmi-digital/components/section";
import { containerClasses } from "@mui/material/Container";

export const ProductLeadBlockWrapper = styled(Section)(({ theme }) => ({
  [`&.${sectionClasses.nonDialog}`]: {
    [theme.breakpoints.down("lg")]: {
      padding: 0,

      [`& .${containerClasses.root}`]: {
        padding: 0
      }
    }
  }
}));
